import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import {
  FormControlLabel,
  FormHelperText,
  Input,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

export default function UpdateOrder({
  open,
  handleClose,
  handleSubmit,
  updateOrderData,
  handleChangeUpdateOrder,
  errors = {},
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Update Order Status"}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", flexDirection: "column", marginBottom: '10px' }}>
                <label>Transaction Status</label>
                <select
                  value={updateOrderData?.transactionStatus}
                  onChange={handleChangeUpdateOrder}
                  name='transactionStatus'
                  style={{
                    padding: "10px",
                    border: "2px solid #c4c4c4",
                    borderRadius: "6px",
                    color: "gray",
                    width: "100%",
                  }}
                >
                  <option value={"pending"}>PENDING</option>
                  <option value={"confirmed"}>CONFIRMED</option>
                  <option value={"declined"}>DECLINED</option>
                  <option value={"refunded"}>REFUNDED</option>
                </select>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Delivery Status</label>
                <select
                  value={updateOrderData?.deliveryStatus}
                  onChange={handleChangeUpdateOrder}
                  name='deliveryStatus'
                  style={{
                    padding: "10px",
                    border: "2px solid #c4c4c4",
                    borderRadius: "6px",
                    color: "gray",
                    width: "100%",
                  }}
                >
                  <option value={"ordered"}>ORDERED</option>
                  <option value={"processing"}>PROCESSING</option>
                  <option value={"canceled"}>CANCELED</option>
                  <option value={"shipping"}>SHIPPING</option>
                  <option value={"delivered"}>DELIVERED</option>
                  <option value={"picked-up"}>PICKED UP</option>
                </select>
              </div>
              {updateOrderData?.deliveryType !== 'pick-up' && (
                <div style={{ display: "flex", flexDirection: "column", marginTop: '10px', color: "gray" }}>
                  <label>Tracking Number</label>
                  {console.log('updateOrderData', updateOrderData)}
                  <input
                    value={updateOrderData?.trackingNumber || ""}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      if (val.length <= 14) {
                        handleChangeUpdateOrder({ target: { name: 'trackingNumber', value: val } });
                      }
                    }}
                    name='trackingNumber'
                    maxLength={14}
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "100%",
                    }}
                  />
                  <FormHelperText error={!!errors.trackingNumber} style={{ fontSize: '12px' }}>
                    {errors.trackingNumber ? errors.trackingNumber : "Enter 14-digit tracking number for non pick-up orders"}
                  </FormHelperText>
                </div>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button autoFocus onClick={handleClose}>
            Disagree
            </Button> */}
            <Button type='submit' autoFocus>
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}
